import React from 'react';
import ReactHlsPlayer from 'react-hls-player';

const MediaLibraryVideoPlayer = React.memo(({url, autoplay = false, width = 500, height = 375}) => {
  return (
    <ReactHlsPlayer
      url={url}
      autoPlay={autoplay}
      controls={true}
      width={width}
      height={height}
      hlsConfig={{
        xhrSetup: function(xhr, url) {
          xhr.withCredentials = true;
        },
      }}
    />
  );
});

export default MediaLibraryVideoPlayer;
